import { ShiftRange } from './shift-range.model';
import { ReportConstants } from 'src/app/smt/reports/shared/report-constants.util';


export class ReportFilters
{
    censusTypes:string[];
    costCenterIds:number[];
    costCenterType:string;
    dateFrom:Date;
    dateTo:Date;
    facilityIds:number[];
    periodEnding:Date;
    periodEndDates:Date[];
    ReportView: string;
    Shifts:ShiftRange[];
    isSummary: boolean;
    ancillaryType:string;
    varianceType : string ;
    shouldDisplayViewFilterColumn() {
        return this.ReportView == ReportConstants.WeekViewLabel
            || this.ReportView == ReportConstants.PeriodEndViewLabel
            || this.ReportView == ReportConstants.DayOfWeekViewLabel;
    }
}